module.exports = '<svg width="20" height="32" viewBox="0 0 20 32"><path d="M10.137 25.277l-8.515 6.387c-.896.671-1.622.31-1.622-.811V2.468C0 1.347 1.046.001 2.66.001h15.143c1.648 0 2.472.981 2.472 2.467v28.385c0 1.121-.726 1.482-1.622.811l-8.515-6.387z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/bookmark-1.js
// module id = 1020
// module chunks = 14